import { createAction } from 'redux-actions';

export const WizardActions = {
  GO_TO_NEXT_PAGE: 'wizard/GO_TO_NEXT_PAGE',
  GO_TO_PREV_PAGE: 'wizard/GO_TO_PREV_PAGE',
  GO_TO_PAGE: 'wizard/GO_TO_PAGE',
  SET_TOTAL_PAGES: 'wizard/SET_TOTAL_PAGES',
};

export const goToNextStepAction = createAction(WizardActions.GO_TO_NEXT_PAGE);
export const goToPrevStepAction = createAction(WizardActions.GO_TO_PREV_PAGE);

export const goToPageAction = (page) => {
  return {
    type: WizardActions.GO_TO_PAGE,
    payload: { page },
  };
};

export const setTotalPagesAction = (total) => {
  return {
    type: WizardActions.SET_TOTAL_PAGES,
    payload: { total },
  };
};
